'use client';
import {useTranslations} from 'next-intl';
import {controlModal} from '@/libs/jquery.util';
import {Link} from "@/i18n/routing";

export default function ProductDetailsCategory({ isModal, category, subcategory }) {
  const t = useTranslations('catalog');
  
  return (
      <li
          onClick={() => {
            isModal ? controlModal() : "";
          }}
      >
        <strong>{t('category')}:</strong>
        <span>
          {
            category ? (
                <Link href={`/catalog?category=${category?.alt}&title=${category?.title}`}>
                  {category?.title}
                </Link>
            ) : (
                <>
                  <Link href={`/catalog?category=${subcategory?.category?.alt}&title=${subcategory?.category?.title}`}>
                    {subcategory?.category?.title}
                  </Link>
                  <Link href={`/catalog?subcategory=${subcategory?.alt}&title=${subcategory?.title}`}>
                    {subcategory?.title}
                  </Link>
                </>
            )
          }
        </span>
      </li>
  );
};
